import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      welcome: 'Welcome',
      active_cases: 'Active Cases',
      pending_payments: 'Pending Payments',
      ai_queries: 'AI Queries',
      register_case: 'Register New Case',
      submit_grievance: 'Submit Grievance',
      law_directory: 'Law Directory',
      ai_assistant: 'AI Assistant',
      logout: 'Logout',
    },
  },
  ur: {
    translation: {
      welcome: 'خوش آمدید',
      active_cases: 'فعال کیسز',
      pending_payments: 'زیر التواء ادائیگیاں',
      ai_queries: 'اے آئی سوالات',
      register_case: 'نیا کیس رجسٹر کریں',
      submit_grievance: 'شکایت درج کریں',
      law_directory: 'قانونی ڈائریکٹری',
      ai_assistant: 'اے آئی اسسٹنٹ',
      logout: 'لاگ آؤٹ',
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
